@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.treedetail.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.treedetail.resources/"

@delegate:ResourceContentHash(715_359_707)
internal val Res.string.treedetail_identity_sheet_save: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_save", "treedetail_identity_sheet_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7428, 54),
      ))
    }

@delegate:ResourceContentHash(-329_660_125)
internal val Res.string.treedetail_identity_sheet_search: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_search", "treedetail_identity_sheet_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7558, 68),
      ))
    }

@delegate:ResourceContentHash(1_229_918_150)
internal val Res.string.treedetail_identity_sheet_search_clear: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_search_clear", "treedetail_identity_sheet_search_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7483, 74),
      ))
    }

@delegate:ResourceContentHash(694_727_719)
internal val Res.string.treedetail_identity_sheet_species_label: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_species_label", "treedetail_identity_sheet_species_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7627, 59),
      ))
    }

@delegate:ResourceContentHash(2_129_603_446)
internal val Res.string.treedetail_identity_sheet_species_title: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_species_title", "treedetail_identity_sheet_species_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7687, 71),
      ))
    }

@delegate:ResourceContentHash(516_503_600)
internal val Res.string.treedetail_identity_sheet_to_confirm: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_to_confirm", "treedetail_identity_sheet_to_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7888, 60),
      ))
    }

@delegate:ResourceContentHash(-399_791_645)
internal val Res.string.treedetail_identity_sheet_to_confirm_description: StringResource by lazy {
      StringResource("string:treedetail_identity_sheet_to_confirm_description", "treedetail_identity_sheet_to_confirm_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7759, 128),
      ))
    }

@delegate:ResourceContentHash(1_732_533_819)
internal val Res.string.treedetail_identity_snackbar_saved: StringResource by lazy {
      StringResource("string:treedetail_identity_snackbar_saved", "treedetail_identity_snackbar_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7949, 74),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_identity_snackbar_undo: StringResource by lazy {
      StringResource("string:treedetail_identity_snackbar_undo", "treedetail_identity_snackbar_undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8096, 53),
      ))
    }

@delegate:ResourceContentHash(956_262_947)
internal val Res.string.treedetail_identity_snackbar_undone: StringResource by lazy {
      StringResource("string:treedetail_identity_snackbar_undone", "treedetail_identity_snackbar_undone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8024, 71),
      ))
    }

@delegate:ResourceContentHash(-1_732_603_260)
internal val Res.string.treedetail_identity_source_bordeaux: StringResource by lazy {
      StringResource("string:treedetail_identity_source_bordeaux", "treedetail_identity_source_bordeaux", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8150, 71),
      ))
    }

@delegate:ResourceContentHash(-1_351_256_524)
internal val Res.string.treedetail_identity_source_grenoble: StringResource by lazy {
      StringResource("string:treedetail_identity_source_grenoble", "treedetail_identity_source_grenoble", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8222, 79),
      ))
    }

@delegate:ResourceContentHash(336_294_656)
internal val Res.string.treedetail_identity_source_lozere: StringResource by lazy {
      StringResource("string:treedetail_identity_source_lozere", "treedetail_identity_source_lozere", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8302, 77),
      ))
    }

@delegate:ResourceContentHash(629_065_721)
internal val Res.string.treedetail_identity_source_lyon: StringResource by lazy {
      StringResource("string:treedetail_identity_source_lyon", "treedetail_identity_source_lyon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8380, 67),
      ))
    }

@delegate:ResourceContentHash(-1_872_402_916)
internal val Res.string.treedetail_identity_source_metz: StringResource by lazy {
      StringResource("string:treedetail_identity_source_metz", "treedetail_identity_source_metz", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8448, 71),
      ))
    }

@delegate:ResourceContentHash(-1_763_112_180)
internal val Res.string.treedetail_identity_source_montpellier: StringResource by lazy {
      StringResource("string:treedetail_identity_source_montpellier", "treedetail_identity_source_montpellier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8520, 98),
      ))
    }

@delegate:ResourceContentHash(1_669_674_684)
internal val Res.string.treedetail_identity_source_nantes: StringResource by lazy {
      StringResource("string:treedetail_identity_source_nantes", "treedetail_identity_source_nantes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8619, 65),
      ))
    }

@delegate:ResourceContentHash(-1_476_095_477)
internal val Res.string.treedetail_identity_source_osm: StringResource by lazy {
      StringResource("string:treedetail_identity_source_osm", "treedetail_identity_source_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8685, 58),
      ))
    }

@delegate:ResourceContentHash(-1_837_758_489)
internal val Res.string.treedetail_identity_source_paris: StringResource by lazy {
      StringResource("string:treedetail_identity_source_paris", "treedetail_identity_source_paris", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8744, 64),
      ))
    }

@delegate:ResourceContentHash(1_854_968_219)
internal val Res.string.treedetail_identity_source_plaine_commune: StringResource by lazy {
      StringResource("string:treedetail_identity_source_plaine_commune", "treedetail_identity_source_plaine_commune", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8809, 69),
      ))
    }

@delegate:ResourceContentHash(2_145_994_099)
internal val Res.string.treedetail_identity_source_rennes: StringResource by lazy {
      StringResource("string:treedetail_identity_source_rennes", "treedetail_identity_source_rennes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8879, 65),
      ))
    }

@delegate:ResourceContentHash(-974_829_259)
internal val Res.string.treedetail_identity_source_strasbourg: StringResource by lazy {
      StringResource("string:treedetail_identity_source_strasbourg", "treedetail_identity_source_strasbourg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8945, 85),
      ))
    }

@delegate:ResourceContentHash(1_242_359_676)
internal val Res.string.treedetail_identity_source_toulouse: StringResource by lazy {
      StringResource("string:treedetail_identity_source_toulouse", "treedetail_identity_source_toulouse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9031, 71),
      ))
    }

@delegate:ResourceContentHash(1_526_134_217)
internal val Res.string.treedetail_identity_species_label: StringResource by lazy {
      StringResource("string:treedetail_identity_species_label", "treedetail_identity_species_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9103, 69),
      ))
    }

@delegate:ResourceContentHash(805_336_521)
internal val Res.string.treedetail_identity_subtitle: StringResource by lazy {
      StringResource("string:treedetail_identity_subtitle", "treedetail_identity_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9173, 116),
      ))
    }

@delegate:ResourceContentHash(-165_847_918)
internal val Res.string.treedetail_identity_title: StringResource by lazy {
      StringResource("string:treedetail_identity_title", "treedetail_identity_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9290, 45),
      ))
    }

@delegate:ResourceContentHash(580_918_303)
internal val Res.string.treedetail_imported_bordeaux: StringResource by lazy {
      StringResource("string:treedetail_imported_bordeaux", "treedetail_imported_bordeaux", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9453, 80),
      ))
    }

@delegate:ResourceContentHash(-1_975_932_576)
internal val Res.string.treedetail_imported_bordeaux_license: StringResource by lazy {
      StringResource("string:treedetail_imported_bordeaux_license", "treedetail_imported_bordeaux_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9336, 116),
      ))
    }

@delegate:ResourceContentHash(-382_651_185)
internal val Res.string.treedetail_imported_grenoble: StringResource by lazy {
      StringResource("string:treedetail_imported_grenoble", "treedetail_imported_grenoble", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9655, 88),
      ))
    }

@delegate:ResourceContentHash(-21_823_029)
internal val Res.string.treedetail_imported_grenoble_license: StringResource by lazy {
      StringResource("string:treedetail_imported_grenoble_license", "treedetail_imported_grenoble_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9534, 120),
      ))
    }

@delegate:ResourceContentHash(1_533_899_880)
internal val Res.string.treedetail_imported_lozere: StringResource by lazy {
      StringResource("string:treedetail_imported_lozere", "treedetail_imported_lozere", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9867, 86),
      ))
    }

@delegate:ResourceContentHash(1_807_923_719)
internal val Res.string.treedetail_imported_lozere_license: StringResource by lazy {
      StringResource("string:treedetail_imported_lozere_license", "treedetail_imported_lozere_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9744, 122),
      ))
    }

@delegate:ResourceContentHash(-1_352_380_012)
internal val Res.string.treedetail_imported_lyon: StringResource by lazy {
      StringResource("string:treedetail_imported_lyon", "treedetail_imported_lyon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10071, 76),
      ))
    }

@delegate:ResourceContentHash(-1_992_151_260)
internal val Res.string.treedetail_imported_lyon_license: StringResource by lazy {
      StringResource("string:treedetail_imported_lyon_license", "treedetail_imported_lyon_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9954, 116),
      ))
    }

@delegate:ResourceContentHash(853_977_655)
internal val Res.string.treedetail_imported_metz: StringResource by lazy {
      StringResource("string:treedetail_imported_metz", "treedetail_imported_metz", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10269, 80),
      ))
    }

@delegate:ResourceContentHash(731_837_511)
internal val Res.string.treedetail_imported_metz_license: StringResource by lazy {
      StringResource("string:treedetail_imported_metz_license", "treedetail_imported_metz_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10148, 120),
      ))
    }

@delegate:ResourceContentHash(-465_423_449)
internal val Res.string.treedetail_imported_montpellier: StringResource by lazy {
      StringResource("string:treedetail_imported_montpellier", "treedetail_imported_montpellier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10490, 107),
      ))
    }

@delegate:ResourceContentHash(1_468_029_603)
internal val Res.string.treedetail_imported_montpellier_license: StringResource by lazy {
      StringResource("string:treedetail_imported_montpellier_license", "treedetail_imported_montpellier_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10350, 139),
      ))
    }

@delegate:ResourceContentHash(-254_949_929)
internal val Res.string.treedetail_imported_nantes: StringResource by lazy {
      StringResource("string:treedetail_imported_nantes", "treedetail_imported_nantes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10709, 74),
      ))
    }

@delegate:ResourceContentHash(-1_001_802_378)
internal val Res.string.treedetail_imported_nantes_license: StringResource by lazy {
      StringResource("string:treedetail_imported_nantes_license", "treedetail_imported_nantes_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10598, 110),
      ))
    }

@delegate:ResourceContentHash(-2_043_647_836)
internal val Res.string.treedetail_imported_osm: StringResource by lazy {
      StringResource("string:treedetail_imported_osm", "treedetail_imported_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10904, 63),
      ))
    }

@delegate:ResourceContentHash(-152_592_787)
internal val Res.string.treedetail_imported_osm_license: StringResource by lazy {
      StringResource("string:treedetail_imported_osm_license", "treedetail_imported_osm_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10784, 119),
      ))
    }

@delegate:ResourceContentHash(532_584_194)
internal val Res.string.treedetail_imported_paris: StringResource by lazy {
      StringResource("string:treedetail_imported_paris", "treedetail_imported_paris", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11074, 73),
      ))
    }

@delegate:ResourceContentHash(-1_053_696_064)
internal val Res.string.treedetail_imported_paris_license: StringResource by lazy {
      StringResource("string:treedetail_imported_paris_license", "treedetail_imported_paris_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10968, 105),
      ))
    }

@delegate:ResourceContentHash(1_754_981_942)
internal val Res.string.treedetail_imported_plaine_commune: StringResource by lazy {
      StringResource("string:treedetail_imported_plaine_commune", "treedetail_imported_plaine_commune", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11263, 78),
      ))
    }

@delegate:ResourceContentHash(1_367_222_485)
internal val Res.string.treedetail_imported_plaine_commune_license: StringResource by lazy {
      StringResource("string:treedetail_imported_plaine_commune_license", "treedetail_imported_plaine_commune_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11148, 114),
      ))
    }

@delegate:ResourceContentHash(221_369_486)
internal val Res.string.treedetail_imported_rennes: StringResource by lazy {
      StringResource("string:treedetail_imported_rennes", "treedetail_imported_rennes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11449, 74),
      ))
    }

@delegate:ResourceContentHash(308_820_300)
internal val Res.string.treedetail_imported_rennes_license: StringResource by lazy {
      StringResource("string:treedetail_imported_rennes_license", "treedetail_imported_rennes_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11342, 106),
      ))
    }

@delegate:ResourceContentHash(672_809_552)
internal val Res.string.treedetail_imported_strasbourg: StringResource by lazy {
      StringResource("string:treedetail_imported_strasbourg", "treedetail_imported_strasbourg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11659, 94),
      ))
    }

@delegate:ResourceContentHash(-928_081_568)
internal val Res.string.treedetail_imported_strasbourg_license: StringResource by lazy {
      StringResource("string:treedetail_imported_strasbourg_license", "treedetail_imported_strasbourg_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11524, 134),
      ))
    }

@delegate:ResourceContentHash(-739_086_057)
internal val Res.string.treedetail_imported_toulouse: StringResource by lazy {
      StringResource("string:treedetail_imported_toulouse", "treedetail_imported_toulouse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11871, 80),
      ))
    }

@delegate:ResourceContentHash(686_512_728)
internal val Res.string.treedetail_imported_toulouse_license: StringResource by lazy {
      StringResource("string:treedetail_imported_toulouse_license", "treedetail_imported_toulouse_license", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11754, 116),
      ))
    }

@delegate:ResourceContentHash(1_938_928_539)
internal val Res.string.treedetail_login_prompt_add_photo: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_add_photo", "treedetail_login_prompt_add_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11952, 89),
      ))
    }

@delegate:ResourceContentHash(-1_012_200_022)
internal val Res.string.treedetail_login_prompt_add_trait: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_add_trait", "treedetail_login_prompt_add_trait", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12042, 89),
      ))
    }

@delegate:ResourceContentHash(-1_884_758_011)
internal val Res.string.treedetail_login_prompt_favorite: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_favorite", "treedetail_login_prompt_favorite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12132, 88),
      ))
    }

@delegate:ResourceContentHash(684_488_041)
internal val Res.string.treedetail_login_prompt_moderate: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_moderate", "treedetail_login_prompt_moderate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12221, 104),
      ))
    }

@delegate:ResourceContentHash(-1_667_380_926)
internal val Res.string.treedetail_login_prompt_observe_status: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_observe_status", "treedetail_login_prompt_observe_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12326, 106),
      ))
    }

@delegate:ResourceContentHash(221_277_464)
internal val Res.string.treedetail_login_prompt_report: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_report", "treedetail_login_prompt_report", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12530, 74),
      ))
    }

@delegate:ResourceContentHash(-17_364_124)
internal val Res.string.treedetail_login_prompt_report_photo: StringResource by lazy {
      StringResource("string:treedetail_login_prompt_report_photo", "treedetail_login_prompt_report_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12433, 96),
      ))
    }

@delegate:ResourceContentHash(867_353_065)
internal val Res.string.treedetail_login_snackbar_action: StringResource by lazy {
      StringResource("string:treedetail_login_snackbar_action", "treedetail_login_snackbar_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12605, 56),
      ))
    }

@delegate:ResourceContentHash(-804_671_236)
internal val Res.string.treedetail_map_preview_cta: StringResource by lazy {
      StringResource("string:treedetail_map_preview_cta", "treedetail_map_preview_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12662, 58),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.treedetail_menu_delete: StringResource by lazy {
      StringResource("string:treedetail_menu_delete", "treedetail_menu_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12721, 42),
      ))
    }

@delegate:ResourceContentHash(-1_523_942_081)
internal val Res.string.treedetail_more_actions_description: StringResource by lazy {
      StringResource("string:treedetail_more_actions_description", "treedetail_more_actions_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12764, 63),
      ))
    }

@delegate:ResourceContentHash(57_027_258)
internal val Res.string.treedetail_move_add_here: StringResource by lazy {
      StringResource("string:treedetail_move_add_here", "treedetail_move_add_here", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12828, 96),
      ))
    }

@delegate:ResourceContentHash(282_536_747)
internal val Res.string.treedetail_move_aim_hint: StringResource by lazy {
      StringResource("string:treedetail_move_aim_hint", "treedetail_move_aim_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12925, 116),
      ))
    }

@delegate:ResourceContentHash(-1_448_899_575)
internal val Res.string.treedetail_move_aim_title: StringResource by lazy {
      StringResource("string:treedetail_move_aim_title", "treedetail_move_aim_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13042, 73),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_move_cancel: StringResource by lazy {
      StringResource("string:treedetail_move_cancel", "treedetail_move_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13116, 42),
      ))
    }

@delegate:ResourceContentHash(249_602_486)
internal val Res.string.treedetail_move_duplicate_confirm: StringResource by lazy {
      StringResource("string:treedetail_move_duplicate_confirm", "treedetail_move_duplicate_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13159, 53),
      ))
    }

@delegate:ResourceContentHash(-1_905_755_132)
internal val Res.string.treedetail_move_duplicate_subtitle: StringResource by lazy {
      StringResource("string:treedetail_move_duplicate_subtitle", "treedetail_move_duplicate_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13213, 86),
      ))
    }

@delegate:ResourceContentHash(1_560_386_225)
internal val Res.string.treedetail_move_duplicate_title: StringResource by lazy {
      StringResource("string:treedetail_move_duplicate_title", "treedetail_move_duplicate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13300, 75),
      ))
    }

@delegate:ResourceContentHash(987_880_241)
internal val Res.string.treedetail_move_legend: StringResource by lazy {
      StringResource("string:treedetail_move_legend", "treedetail_move_legend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13376, 82),
      ))
    }

@delegate:ResourceContentHash(-1_639_027_470)
internal val Res.string.treedetail_move_recenter: StringResource by lazy {
      StringResource("string:treedetail_move_recenter", "treedetail_move_recenter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13459, 64),
      ))
    }

@delegate:ResourceContentHash(-736_084_478)
internal val Res.string.treedetail_move_report_gone: StringResource by lazy {
      StringResource("string:treedetail_move_report_gone", "treedetail_move_report_gone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13524, 71),
      ))
    }

@delegate:ResourceContentHash(-1_892_929_633)
internal val Res.string.treedetail_move_save: StringResource by lazy {
      StringResource("string:treedetail_move_save", "treedetail_move_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13596, 60),
      ))
    }

@delegate:ResourceContentHash(-1_121_869_583)
internal val Res.string.treedetail_move_title: StringResource by lazy {
      StringResource("string:treedetail_move_title", "treedetail_move_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13732, 53),
      ))
    }

@delegate:ResourceContentHash(-2_108_155_714)
internal val Res.string.treedetail_move_title_expanded: StringResource by lazy {
      StringResource("string:treedetail_move_title_expanded", "treedetail_move_title_expanded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13657, 74),
      ))
    }

@delegate:ResourceContentHash(-40_306_029)
internal val Res.string.treedetail_move_too_far_body: StringResource by lazy {
      StringResource("string:treedetail_move_too_far_body", "treedetail_move_too_far_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13786, 140),
      ))
    }

@delegate:ResourceContentHash(1_295_550_890)
internal val Res.string.treedetail_move_too_far_title: StringResource by lazy {
      StringResource("string:treedetail_move_too_far_title", "treedetail_move_too_far_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13927, 77),
      ))
    }

@delegate:ResourceContentHash(-1_265_552_595)
internal val Res.string.treedetail_not_found_back: StringResource by lazy {
      StringResource("string:treedetail_not_found_back", "treedetail_not_found_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14005, 57),
      ))
    }

@delegate:ResourceContentHash(1_489_245_451)
internal val Res.string.treedetail_not_found_message: StringResource by lazy {
      StringResource("string:treedetail_not_found_message", "treedetail_not_found_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14063, 116),
      ))
    }

@delegate:ResourceContentHash(-1_610_088_588)
internal val Res.string.treedetail_not_found_title: StringResource by lazy {
      StringResource("string:treedetail_not_found_title", "treedetail_not_found_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14180, 94),
      ))
    }

@delegate:ResourceContentHash(-1_461_757_523)
internal val Res.string.treedetail_observation_empty: StringResource by lazy {
      StringResource("string:treedetail_observation_empty", "treedetail_observation_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14275, 68),
      ))
    }

@delegate:ResourceContentHash(305_686_484)
internal val Res.string.treedetail_observation_label: StringResource by lazy {
      StringResource("string:treedetail_observation_label", "treedetail_observation_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14344, 56),
      ))
    }

@delegate:ResourceContentHash(1_347_467_744)
internal val Res.string.treedetail_observation_latest: StringResource by lazy {
      StringResource("string:treedetail_observation_latest", "treedetail_observation_latest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14401, 85),
      ))
    }

@delegate:ResourceContentHash(1_367_288_911)
internal val Res.string.treedetail_observation_option_flowering: StringResource by lazy {
      StringResource("string:treedetail_observation_option_flowering", "treedetail_observation_option_flowering", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14487, 67),
      ))
    }

@delegate:ResourceContentHash(-534_294_247)
internal val Res.string.treedetail_observation_option_picked: StringResource by lazy {
      StringResource("string:treedetail_observation_option_picked", "treedetail_observation_option_picked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14555, 56),
      ))
    }

@delegate:ResourceContentHash(1_405_459_023)
internal val Res.string.treedetail_observation_option_ripe: StringResource by lazy {
      StringResource("string:treedetail_observation_option_ripe", "treedetail_observation_option_ripe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14612, 66),
      ))
    }

@delegate:ResourceContentHash(1_472_570_709)
internal val Res.string.treedetail_observation_stale: StringResource by lazy {
      StringResource("string:treedetail_observation_stale", "treedetail_observation_stale", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14679, 108),
      ))
    }

@delegate:ResourceContentHash(-1_903_304_889)
internal val Res.string.treedetail_observation_status_long_flowering: StringResource by lazy {
      StringResource("string:treedetail_observation_status_long_flowering", "treedetail_observation_status_long_flowering", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14788, 72),
      ))
    }

@delegate:ResourceContentHash(498_367_505)
internal val Res.string.treedetail_observation_status_long_picked: StringResource by lazy {
      StringResource("string:treedetail_observation_status_long_picked", "treedetail_observation_status_long_picked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14861, 61),
      ))
    }

@delegate:ResourceContentHash(467_364_481)
internal val Res.string.treedetail_observation_status_long_ripe: StringResource by lazy {
      StringResource("string:treedetail_observation_status_long_ripe", "treedetail_observation_status_long_ripe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14923, 71),
      ))
    }

@delegate:ResourceContentHash(-379_551_485)
internal val Res.string.treedetail_observation_tile_description: StringResource by lazy {
      StringResource("string:treedetail_observation_tile_description", "treedetail_observation_tile_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14995, 67),
      ))
    }

@delegate:ResourceContentHash(379_609_069)
internal val Res.string.treedetail_observation_title: StringResource by lazy {
      StringResource("string:treedetail_observation_title", "treedetail_observation_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15063, 84),
      ))
    }

@delegate:ResourceContentHash(1_821_633_350)
internal val Res.string.treedetail_photo_add: StringResource by lazy {
      StringResource("string:treedetail_photo_add", "treedetail_photo_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15199, 52),
      ))
    }

@delegate:ResourceContentHash(959_062_920)
internal val Res.string.treedetail_photo_added: StringResource by lazy {
      StringResource("string:treedetail_photo_added", "treedetail_photo_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15148, 50),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.treedetail_photo_close_description: StringResource by lazy {
      StringResource("string:treedetail_photo_close_description", "treedetail_photo_close_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15252, 50),
      ))
    }

@delegate:ResourceContentHash(949_228_253)
internal val Res.string.treedetail_photo_delete_description: StringResource by lazy {
      StringResource("string:treedetail_photo_delete_description", "treedetail_photo_delete_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15303, 71),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.treedetail_photo_delete_dialog_cancel: StringResource by lazy {
      StringResource("string:treedetail_photo_delete_dialog_cancel", "treedetail_photo_delete_dialog_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15375, 57),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.treedetail_photo_delete_dialog_confirm: StringResource by lazy {
      StringResource("string:treedetail_photo_delete_dialog_confirm", "treedetail_photo_delete_dialog_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15433, 58),
      ))
    }

@delegate:ResourceContentHash(2_005_485_580)
internal val Res.string.treedetail_photo_delete_dialog_text: StringResource by lazy {
      StringResource("string:treedetail_photo_delete_dialog_text", "treedetail_photo_delete_dialog_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15492, 135),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("treedetail_identity_sheet_save", Res.string.treedetail_identity_sheet_save)
  map.put("treedetail_identity_sheet_search", Res.string.treedetail_identity_sheet_search)
  map.put("treedetail_identity_sheet_search_clear", Res.string.treedetail_identity_sheet_search_clear)
  map.put("treedetail_identity_sheet_species_label", Res.string.treedetail_identity_sheet_species_label)
  map.put("treedetail_identity_sheet_species_title", Res.string.treedetail_identity_sheet_species_title)
  map.put("treedetail_identity_sheet_to_confirm", Res.string.treedetail_identity_sheet_to_confirm)
  map.put("treedetail_identity_sheet_to_confirm_description", Res.string.treedetail_identity_sheet_to_confirm_description)
  map.put("treedetail_identity_snackbar_saved", Res.string.treedetail_identity_snackbar_saved)
  map.put("treedetail_identity_snackbar_undo", Res.string.treedetail_identity_snackbar_undo)
  map.put("treedetail_identity_snackbar_undone", Res.string.treedetail_identity_snackbar_undone)
  map.put("treedetail_identity_source_bordeaux", Res.string.treedetail_identity_source_bordeaux)
  map.put("treedetail_identity_source_grenoble", Res.string.treedetail_identity_source_grenoble)
  map.put("treedetail_identity_source_lozere", Res.string.treedetail_identity_source_lozere)
  map.put("treedetail_identity_source_lyon", Res.string.treedetail_identity_source_lyon)
  map.put("treedetail_identity_source_metz", Res.string.treedetail_identity_source_metz)
  map.put("treedetail_identity_source_montpellier", Res.string.treedetail_identity_source_montpellier)
  map.put("treedetail_identity_source_nantes", Res.string.treedetail_identity_source_nantes)
  map.put("treedetail_identity_source_osm", Res.string.treedetail_identity_source_osm)
  map.put("treedetail_identity_source_paris", Res.string.treedetail_identity_source_paris)
  map.put("treedetail_identity_source_plaine_commune", Res.string.treedetail_identity_source_plaine_commune)
  map.put("treedetail_identity_source_rennes", Res.string.treedetail_identity_source_rennes)
  map.put("treedetail_identity_source_strasbourg", Res.string.treedetail_identity_source_strasbourg)
  map.put("treedetail_identity_source_toulouse", Res.string.treedetail_identity_source_toulouse)
  map.put("treedetail_identity_species_label", Res.string.treedetail_identity_species_label)
  map.put("treedetail_identity_subtitle", Res.string.treedetail_identity_subtitle)
  map.put("treedetail_identity_title", Res.string.treedetail_identity_title)
  map.put("treedetail_imported_bordeaux", Res.string.treedetail_imported_bordeaux)
  map.put("treedetail_imported_bordeaux_license", Res.string.treedetail_imported_bordeaux_license)
  map.put("treedetail_imported_grenoble", Res.string.treedetail_imported_grenoble)
  map.put("treedetail_imported_grenoble_license", Res.string.treedetail_imported_grenoble_license)
  map.put("treedetail_imported_lozere", Res.string.treedetail_imported_lozere)
  map.put("treedetail_imported_lozere_license", Res.string.treedetail_imported_lozere_license)
  map.put("treedetail_imported_lyon", Res.string.treedetail_imported_lyon)
  map.put("treedetail_imported_lyon_license", Res.string.treedetail_imported_lyon_license)
  map.put("treedetail_imported_metz", Res.string.treedetail_imported_metz)
  map.put("treedetail_imported_metz_license", Res.string.treedetail_imported_metz_license)
  map.put("treedetail_imported_montpellier", Res.string.treedetail_imported_montpellier)
  map.put("treedetail_imported_montpellier_license", Res.string.treedetail_imported_montpellier_license)
  map.put("treedetail_imported_nantes", Res.string.treedetail_imported_nantes)
  map.put("treedetail_imported_nantes_license", Res.string.treedetail_imported_nantes_license)
  map.put("treedetail_imported_osm", Res.string.treedetail_imported_osm)
  map.put("treedetail_imported_osm_license", Res.string.treedetail_imported_osm_license)
  map.put("treedetail_imported_paris", Res.string.treedetail_imported_paris)
  map.put("treedetail_imported_paris_license", Res.string.treedetail_imported_paris_license)
  map.put("treedetail_imported_plaine_commune", Res.string.treedetail_imported_plaine_commune)
  map.put("treedetail_imported_plaine_commune_license", Res.string.treedetail_imported_plaine_commune_license)
  map.put("treedetail_imported_rennes", Res.string.treedetail_imported_rennes)
  map.put("treedetail_imported_rennes_license", Res.string.treedetail_imported_rennes_license)
  map.put("treedetail_imported_strasbourg", Res.string.treedetail_imported_strasbourg)
  map.put("treedetail_imported_strasbourg_license", Res.string.treedetail_imported_strasbourg_license)
  map.put("treedetail_imported_toulouse", Res.string.treedetail_imported_toulouse)
  map.put("treedetail_imported_toulouse_license", Res.string.treedetail_imported_toulouse_license)
  map.put("treedetail_login_prompt_add_photo", Res.string.treedetail_login_prompt_add_photo)
  map.put("treedetail_login_prompt_add_trait", Res.string.treedetail_login_prompt_add_trait)
  map.put("treedetail_login_prompt_favorite", Res.string.treedetail_login_prompt_favorite)
  map.put("treedetail_login_prompt_moderate", Res.string.treedetail_login_prompt_moderate)
  map.put("treedetail_login_prompt_observe_status", Res.string.treedetail_login_prompt_observe_status)
  map.put("treedetail_login_prompt_report", Res.string.treedetail_login_prompt_report)
  map.put("treedetail_login_prompt_report_photo", Res.string.treedetail_login_prompt_report_photo)
  map.put("treedetail_login_snackbar_action", Res.string.treedetail_login_snackbar_action)
  map.put("treedetail_map_preview_cta", Res.string.treedetail_map_preview_cta)
  map.put("treedetail_menu_delete", Res.string.treedetail_menu_delete)
  map.put("treedetail_more_actions_description", Res.string.treedetail_more_actions_description)
  map.put("treedetail_move_add_here", Res.string.treedetail_move_add_here)
  map.put("treedetail_move_aim_hint", Res.string.treedetail_move_aim_hint)
  map.put("treedetail_move_aim_title", Res.string.treedetail_move_aim_title)
  map.put("treedetail_move_cancel", Res.string.treedetail_move_cancel)
  map.put("treedetail_move_duplicate_confirm", Res.string.treedetail_move_duplicate_confirm)
  map.put("treedetail_move_duplicate_subtitle", Res.string.treedetail_move_duplicate_subtitle)
  map.put("treedetail_move_duplicate_title", Res.string.treedetail_move_duplicate_title)
  map.put("treedetail_move_legend", Res.string.treedetail_move_legend)
  map.put("treedetail_move_recenter", Res.string.treedetail_move_recenter)
  map.put("treedetail_move_report_gone", Res.string.treedetail_move_report_gone)
  map.put("treedetail_move_save", Res.string.treedetail_move_save)
  map.put("treedetail_move_title", Res.string.treedetail_move_title)
  map.put("treedetail_move_title_expanded", Res.string.treedetail_move_title_expanded)
  map.put("treedetail_move_too_far_body", Res.string.treedetail_move_too_far_body)
  map.put("treedetail_move_too_far_title", Res.string.treedetail_move_too_far_title)
  map.put("treedetail_not_found_back", Res.string.treedetail_not_found_back)
  map.put("treedetail_not_found_message", Res.string.treedetail_not_found_message)
  map.put("treedetail_not_found_title", Res.string.treedetail_not_found_title)
  map.put("treedetail_observation_empty", Res.string.treedetail_observation_empty)
  map.put("treedetail_observation_label", Res.string.treedetail_observation_label)
  map.put("treedetail_observation_latest", Res.string.treedetail_observation_latest)
  map.put("treedetail_observation_option_flowering", Res.string.treedetail_observation_option_flowering)
  map.put("treedetail_observation_option_picked", Res.string.treedetail_observation_option_picked)
  map.put("treedetail_observation_option_ripe", Res.string.treedetail_observation_option_ripe)
  map.put("treedetail_observation_stale", Res.string.treedetail_observation_stale)
  map.put("treedetail_observation_status_long_flowering", Res.string.treedetail_observation_status_long_flowering)
  map.put("treedetail_observation_status_long_picked", Res.string.treedetail_observation_status_long_picked)
  map.put("treedetail_observation_status_long_ripe", Res.string.treedetail_observation_status_long_ripe)
  map.put("treedetail_observation_tile_description", Res.string.treedetail_observation_tile_description)
  map.put("treedetail_observation_title", Res.string.treedetail_observation_title)
  map.put("treedetail_photo_add", Res.string.treedetail_photo_add)
  map.put("treedetail_photo_added", Res.string.treedetail_photo_added)
  map.put("treedetail_photo_close_description", Res.string.treedetail_photo_close_description)
  map.put("treedetail_photo_delete_description", Res.string.treedetail_photo_delete_description)
  map.put("treedetail_photo_delete_dialog_cancel", Res.string.treedetail_photo_delete_dialog_cancel)
  map.put("treedetail_photo_delete_dialog_confirm", Res.string.treedetail_photo_delete_dialog_confirm)
  map.put("treedetail_photo_delete_dialog_text", Res.string.treedetail_photo_delete_dialog_text)
}
